import { SelectChangeEvent } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import BorderHeading from '../../components/heading/BorderHeading'
import "./OrderConfiguration.css"
import { DashboardCheckbox, DashboardSelect, InputList } from '../../components/Input/Input';
import Input from "../../components/Input/Input"
import store from '../../stateManagement/store';
import { configurationAttributeType, orderConfigurationValuesTypes} from '../../types';
import * as yup from 'yup';
import ConfigurationHeader from '../../components/heading/ConfigurationHeader';
import { convertValuesToConfig, createValidation, doFinalConfigSubmit, getMetaData, getMetaDataConfig, getNewConfiguration, overWriteConfig, postConfiguration, updateConfiguration } from '../../services/uiConfigService';
import { defaultInputValues } from '../../components/constants/uiConfigConstants';
import * as Sentry from "@sentry/react";
import QuestionHeading from '../../components/heading/QuestionHeading';
import { validateWithOtp } from '../../stateManagement/actions/validateOtpPopupActions';
import { openPopup } from '../../stateManagement/actions/popupActions';
import { IndentWrapper } from './OrderConfiguration';
import { deepClone } from '@mui/x-data-grid/utils/utils';
import ConfigComparePopup from '../../components/popup/ConfigComparePopup';
import { manageUpdateAccessObj } from '../manageUpdateAccess/manageUpdateAccessTypes';
import ImportConfig from '../../components/importConfig/ImportConfig';



const CheckoutConfiguration = () => {
    const [orderConfig, setOrderConfig] = useState<configurationAttributeType[]>([]);
    const [values, setValues] = useState<orderConfigurationValuesTypes>(deepClone(defaultInputValues))
    const [orderValidationsSchema, setOrderValidationSchema] = useState({})

    const [showConfigPopup,setShowConfigPopup] = useState<boolean>(false);
    const curConfigRef = useRef<{[key:string]:any[]}>({});
    const newConfigRef = useRef<{[key:string]:any[]}>({});


    const getOrderConfiguration = async () => {
        try {
            const resp = await getNewConfiguration('order_configuration');
            const order_config: configurationAttributeType[] = resp?.domainValues;
            curConfigRef.current.order_configuration = order_config  ?? [];
            setOrderConfig([...order_config])
        } catch (err) {
            // Sentry.captureException(err);
        }
    }
    useEffect(() => {

        getOrderConfiguration();
    }, [])
    const handleCheckChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const keyName = e.target.name;
        setValues({
            ...values,
            [keyName]: {...values[keyName], value:e.target.checked, isValueUpdated:true} 
        })
    }
    const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const keyName = e.target.name;
        setValues({
            ...values,
            [keyName]: {...values[keyName], value:e.target.value, isValueUpdated:true} 
        })
    }


    const handleSelectValueChange = (e: SelectChangeEvent<unknown>) => {
        const keyName = e.target.name;
        setValues({
            ...values,
            [keyName]: {...values[keyName], value:e.target.value, isValueUpdated:true} 
        });
    }
    const handleDisclaimerChange = ( e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        switch(e.target.name){
            case 'orderSummaryDisclaimer' :{
                const finalDisclaimer = [...values.orderSummaryDisclaimer.value];
                finalDisclaimer[index] = e.target.value;
                const keyName = e.target.name;
                setValues({
                    ...values,
                    [keyName]: {...values[keyName], value:[...finalDisclaimer], isValueUpdated:true} 
                })
                break;
            }
        }
    }

    const setOrderConfigValues = () => {
        try {
            if (orderConfig.length) {
                const result = { ...values };
                const resValidations = {} as { [key: string]: ReturnType<typeof createValidation> }
                orderConfig.forEach((attr) => {
                    resValidations[attr.name] = createValidation(attr)
                    result[attr.name] = attr;
                })
                setValues({ ...result } as orderConfigurationValuesTypes);
                setOrderValidationSchema({ ...resValidations })
            }
        } catch (err) {
            // Sentry.captureException(err);
        }
    }

    const saveConfiguration = async (preview?: boolean) => {
            try {
                const resultantValues:orderConfigurationValuesTypes = { ...values};
                const orderSchema = yup.object({ ...orderValidationsSchema })
                const validationObject:any = {};
                Object.keys(resultantValues).forEach(key=>{
                    validationObject[key] = resultantValues[key].value;
                })
                // await orderSchema.validate(validationObject)
                const convertedVals = convertValuesToConfig(resultantValues, orderConfig);
                newConfigRef.current.order_configuration = convertedVals;
                setShowConfigPopup(true);

            } catch (err) {
                // Sentry.captureException(err);
                console.log("err===", err)
                if (err instanceof Error)
                    openPopup( 'Error',"Validation Error occured : " + err?.message)
            }
    }


    useEffect(() => {
        setOrderConfigValues();
    }, [orderConfig])


    const importConfiguration = async (importedConfig:any)=>{
        const newConfigs = await overWriteConfig(importedConfig, {
            // order_configuration:["distributorVisibility","orderDSIdVisibility","retailerMarginVisibility","showFreeProductLabel","orderRemarksVisibility","amountCalculation","schemeCalculation","orderSummaryDisclaimer","orderCheckoutPtrLabel","orderCheckoutUnitLabel","orderCheckoutFinalAmountLabel","orderCheckoutTotalAmountLabel"]
            order_configuration:"importAll"
        })
        newConfigs.forEach((item) => {
            newConfigRef.current[item.domainType] = item.domainValues;
        });
        setShowConfigPopup(true);
    }

    const  onConfigComparatorSuccess=async () => {
        await doFinalConfigSubmit("order_configuration",newConfigRef.current.order_configuration,curConfigRef)
        getOrderConfiguration();
      }

    const [importConfigState,setImportConfigState] = useState(false);


    return (
        <div className="order_config_container">
            <ImportConfig importConfigState={importConfigState} setImportConfigState={setImportConfigState} configNames={['order_configuration']} importConfigCallback={importConfiguration} />
            <ConfigurationHeader heading={"Checkout Configuration"} importConfiguration={()=>{setImportConfigState(true)}} saveConfiguration={() => saveConfiguration(false)} />
            <div className="config_form_container">


            <div className="form_header">
                    <BorderHeading>CHECKOUT PAGE</BorderHeading>
                </div>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    orderTermsAndConditionVisibility
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.orderTermsAndConditionVisibility.value} name="orderTermsAndConditionVisibility" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    orderConfirmationPopup
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.orderConfirmationPopup.value} name="orderConfirmationPopup" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={1}>
                    <QuestionHeading>
                        Do you want to show distributor visibility and details?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.distributorVisibility.value} name="distributorVisibility" label="Yes" />
                    </div>
                </IndentWrapper>
                <IndentWrapper indent={1}>
                    <QuestionHeading>
                    Can the user see the distributor ID on checkout page?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.orderDSIdVisibility.value} name="orderDSIdVisibility" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={1}>
                    <QuestionHeading>
                    Do you want the user to see the retailer margin?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.retailerMarginVisibility.value} name="retailerMarginVisibility" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={1}>
                    <QuestionHeading>
                    Do you want that the free label to be displayed alongside the free product? 
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.showFreeProductLabel.value} name="showFreeProductLabel" label="Yes" />
                    </div>
                </IndentWrapper>
                

                <IndentWrapper indent={1}>
                    <QuestionHeading>
                        Do you wish to have any remarks for Order?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.orderRemarksVisibility.value} name="orderRemarksVisibility" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={1}>
                    <QuestionHeading>
                    Do you want display the total amount calculation?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.amountCalculation.value} name="amountCalculation" label="Yes" />
                    </div>
                </IndentWrapper>

                {/* <IndentWrapper indent={1}>
                    <QuestionHeading>
                    is the minimum order condition visible to the user?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.minOrderVisibility.value} name="minOrderVisibility" label="Yes" />
                    </div>
                </IndentWrapper> */}

                <IndentWrapper indent={1}>
                    <QuestionHeading>
                        How should the scheme be calculated?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardSelect onChange={handleSelectValueChange} value={values.schemeCalculation.value} name="schemeCalculation" options={values.schemeCalculation.possibleVals ?? []} selectLableId='Select where to calculate scheme' />
                    </div>
                </IndentWrapper>


                {/* <IndentWrapper indent={1}>
                    <QuestionHeading>
                        Do you wish to have disclaimers?
                    </QuestionHeading>
                    <div className="generic_form_container even_container">
                        <Input value={values.orderSummaryDisclaimer?.value?.[0]} onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleDisclaimerChange(e, 0)} name="orderSummaryDisclaimer" />
                        <Input value={values.orderSummaryDisclaimer?.value?.[1]} onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleDisclaimerChange(e, 1)} name="orderSummaryDisclaimer" />
                    </div>
                </IndentWrapper> */}

                <IndentWrapper indent={1}>
                    <InputList values={values} question="Do you wish to have disclaimers?" setValues={setValues} configName="orderSummaryDisclaimer" />
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    What should be the label for PTR on the checkout page?
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.orderCheckoutPtrLabel.value} onChange={handleValueChange} name="orderCheckoutPtrLabel" />
                    </div>
                </IndentWrapper>
                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    What should be the label of the unit in order summary?
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.orderCheckoutUnitLabel.value} onChange={handleValueChange} name="orderCheckoutUnitLabel" />
                    </div>
                </IndentWrapper>
                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    What should be the label of the final amount?
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.orderCheckoutFinalAmountLabel.value} onChange={handleValueChange} name="orderCheckoutFinalAmountLabel" />
                    </div>
                </IndentWrapper>
                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    What should be the label of the total amount?
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.orderCheckoutTotalAmountLabel.value} onChange={handleValueChange} name="orderCheckoutTotalAmountLabel" />
                    </div>
                </IndentWrapper>


            </div>
            <ConfigComparePopup message="Are you sure want to update the config" showConfigPopup={showConfigPopup} setShowConfigPopup={setShowConfigPopup} curConfig={curConfigRef.current} newConfig={newConfigRef.current} onSuccess={onConfigComparatorSuccess} />
        </div>
    )
}

export default CheckoutConfiguration